<template>
  <div class="subscription-licences pa-10" v-if="subscription">

    <v-breadcrumbs
        class="level-2"
        :items="[
            {text: $tc('subscription.subscription', 2), to: {name: 'organizations.subscriptions'}, exact: true},
            {text: localizedString(subscription.subscriptionPlan.label), to: {name: 'organizations.subscriptions.edit'} },
            {text: $t('subscription.manage-licences') },
        ]"
        divider=">"
    ></v-breadcrumbs>


    <subscription-licences-list :subscription-id="subscription.id">
      <template #actions><audit-trail-button class="ml-2" entity-type="SubscriptionLicence" :organization-id="$route.params.id" /></template>
    </subscription-licences-list>


  </div>
</template>

<script>


import SubscriptionLicencesList from "@/components/elements/SubscriptionLicencesList.vue";
import SubscriptionRepository from "@repository/SubscriptionRepository";
import AuditTrailButton from "@elements/AuditTrailButton.vue";

export default {
  components: {
    AuditTrailButton,
    SubscriptionLicencesList,
  },

  data() {
    return {
      subscription: null,
    }
  },



  mounted() {
    this.loadData()
  },

  watch: {

  },

  computed: {


  },

  methods: {
    loadData() {
      this.showLoading(true)
      SubscriptionRepository.get(this.$route.params.subscriptionId).then(data => {
        this.subscription = data
        this.showLoading(false)
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    },
  },

}
</script>

<style lang="scss">

</style>
